<template>
  <GDialog
    :value="value"
    title="Sinoa Guide"
    width="60%"
    height="650"
    @input="$emit('input', false)"
  >
    <v-card
      class="elevation-0"
    >
      <v-card-text>
        <h2
          :style="{ color: COLORS.grainfoxAIButton }"
        >
          How Sinoa Works
        </h2>

        <br>

        <div class="primary-grey--text">
          <p>
            Ask Sinoa any question in plain english. When you add a few details - like who you are, where you're
            located, what crop you're growing, or what you want to know - Sinoa can dig in and
            give you a much sharper response.
          </p>

          <ul>
            <li>
              <strong>Questions Remaining</strong>
              (above the input field) tracks the questions in your pack as you use them. You can buy more at any
              time so you don't run out!
            </li>

            <li>
              <strong>Today's Top Questions</strong>
              are always free and don't count toward your Questions Remaining credits.
            </li>
          </ul>
        </div>

        <br>
        <br>

        <h2
          :style="{ color: COLORS.grainfoxAIButton }"
        >
          What Sinoa Can Do
        </h2>

        <br>

        <div class="primary-grey--text">
          <p>
            <strong><em>Sinoa</em></strong>
            is built to explain the market, put signals in context, and turn information into strategy.
          </p>

          <p>
            <strong>Here's how it can help you:</strong>
          </p>

          <ul>
            <li>
              <strong>Understand the market:</strong>
              Get clear explanations of special reports like WASDE/USDA updates, analyst outlooks,
              and weather impacts.
            </li>

            <li>
              <strong>Compare with context:</strong>
              Analyze different regions, delivery months, or historical trends.
            </li>

            <li>
              <strong>Turn insights into action:</strong>
              Translate market moves into practical steps - like percent-to-sell or hedge ideas.
            </li>

            <li>
              <strong>Save time on research:</strong>
              Summarize long reports and highlight what matters most for your farm or desk.
            </li>
          </ul>

          <br>

          <h4 class="mb-2">
            For Live Market Numbers
          </h4>

          <p>
            <strong><em>Sinoa</em></strong>
            focuses on interpretation and strategy, not live data. For the most current, precise figures,
            check these tools in your GrainFox account:
          </p>

          <ul>
            <li>
              <strong>Live Prices & Futures:</strong>
              The GrainFox Dashboard shows up-to-the-minute quotes:
              <a href="/dashboard">
                <v-icon
                  small
                  class="mr-1"
                  color="primary"
                >
                  mdi-view-dashboard
                </v-icon>
                <strong>Dashboard</strong>
                <v-icon
                  color="primary-grey--text"
                >
                  mdi-chevron-right
                </v-icon>
              </a>
            </li>

            <li>
              <strong>Basis Map / Bid Finder:</strong>
              Price Finder is where you'll find local basis and buyer bids:
              <a href="/bids/map">
                <v-icon
                  small
                  class="mr-1"
                  color="primary"
                >
                  mdi-currency-usd
                </v-icon>
                <strong>Price Finder</strong>
                <v-icon
                  color="primary-grey--text"
                >
                  mdi-chevron-right
                </v-icon>
              </a>
            </li>

            <li>
              <strong>Smart Advisor:</strong>
              This is where your personalized sales targets and alerts are:
              <a href="/budgeting/ai_advisor">
                <v-icon
                  small
                  class="mr-1"
                  color="primary"
                >
                  $vuetify.icons.smartAdvisor
                </v-icon>
                <strong>Smart Advisor</strong>
                <v-icon
                  color="primary-grey--text"
                >
                  mdi-chevron-right
                </v-icon>
              </a>
            </li>

            <li>
              <strong>Analyst Charts:</strong>
              The Market Insights Dashboard shows verified price and basis trends for Commercial clients:
              <a href="/insights/overview">
                <v-icon
                  small
                  class="mr-1"
                  color="primary"
                >
                  mdi-eye-circle-outline
                </v-icon>
                <strong>Market Insights</strong>
                <v-icon
                  color="primary-grey--text"
                >
                  mdi-chevron-right
                </v-icon>
              </a>
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </GDialog>
</template>

<script>
import GDialog from '@/components/generic/GDialog.vue';
import { COLORS } from '@/helpers/colors';

export default {
  name: 'SinoaGuideDialog',

  components: {
    GDialog,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      COLORS,
    };
  },
};
</script>
